import React, { ReactElement, createContext, FC, useContext, useState } from 'react'
import { generateUserUuid } from '../../utils/generateUuid'
import { loadPersistentState, savePersistentState } from '../../utils/localStorageIO'
import { TUserContext } from './types'

const initialState = { uuid: generateUserUuid() }
const UserContext = createContext<TUserContext>(initialState)

const storageKey = 'pollabUser'
type Props = {
    children: ReactElement
}

const UserProvider: FC<Props> = ({ children }) => {
    const init = () => {
        try {
            const storage = loadPersistentState<TUserContext>(storageKey) as TUserContext
            if (!storage) {
                savePersistentState(storageKey, initialState)
                return initialState
            }
            return storage
        } catch (ignore) {
            return initialState
        }
    }

    const [user] = useState<TUserContext>(init())

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}

function useUserState(): TUserContext {
    const context = useContext(UserContext)
    if (context === undefined) {
        throw new Error('useUserState must be used within a UserContext')
    }
    return context
}

export { UserProvider, useUserState }
